import React from 'react';

// Near-black top bar with the light-on-dark Butler Direct logo
export const BrandTopBar = ({ subtitle, children, testId = 'brand-top-bar' }) => (
  <header className="bd-topbar sticky top-0 z-40" data-testid={testId}>
    <div className="mx-auto flex max-w-[1600px] items-center justify-between gap-3 px-4 py-3">
      <div className="flex min-w-0 items-center gap-3">
        <img
          src="/butler-direct-logo-horizontal-dark.png"
          alt="Butler Direct"
          className="h-8 w-auto shrink-0 sm:h-9"
        />
        {subtitle && (
          <span className="hidden min-w-0 truncate border-l border-gold/30 pl-3 text-xs font-medium text-cream/70 sm:block">
            {subtitle}
          </span>
        )}
      </div>
      <div className="flex shrink-0 items-center gap-2">{children}</div>
    </div>
  </header>
);

export default BrandTopBar;
